import {
  Vue, Options
} from 'vue-class-component'
import swal from 'sweetalert'
import Header from '@/components/Header.vue'
import { orderFactory } from '@/http/order'
import { billFactory } from '@/http/bill'
import { masterDataFactory } from '@/http/master-data'
import roleAccessManager from '@/utils/role-access-manager'

@Options({
  components: {
    Header
  },
  data () {
    return {
      va_file: '',
      expired_file: '',
      bill_options: [],
      selected_bill: 0,
      selected_bill2: 0,
      canCreate: false,
      canRead: false,
      canUpdate: false,
      canDelete: false
    }
  },
  methods: {
    handleVAFileUpload: function () {
      this.va_file = this.$refs.va_file.files[0]
    },
    handleExpireFileUpload: function () {
      this.expired_file = this.$refs.expired_file.files[0]
    },
    importFile: function (fileName: string) {
      if (this[fileName] == '') {
        swal('Harap pilih berkas yang akan diimpor', '', 'error')
        return
      }

      const formData = new FormData()
      formData.append('excel', this[fileName])

      if (fileName == 'va_file') {
        if (!this.selected_bill) {
          swal('Harap pilih tagihan yang akan digunakan', '', 'error')
          return
        }
        formData.append('spp_bill_id', this.selected_bill)

        Promise.resolve(orderFactory.importVAOrder(formData))
          .then((response) => {
            // check if is set errmessage
            if (response.data.errmessage) {
              swal({
                title: 'Error',
                icon: 'error',
                // className: 'swal-large',
                closeOnClickOutside: false,
                content: {
                  element: 'div',
                  attributes: {
                    innerHTML: '<ul style="text-align: left">' + response.data.errmessage.map((err: any) => `<li>${err}</li>`).join('') + '</ul>',
                    style: 'text-align: left'
                  }
                }
                // button: "OK",
              })
              this.va_file = ''
              // reset #import-file-expired input file
              this.$refs.va_file.value = ''
              this.selected_bill = 0
              return
            }
            let failmessages = '<ul style="text-align: left">'
            let successmessages = '<ul style="text-align: left">'
            let successCount = 0
            let failCount = 0
            const result_by_nis = response.data.result_by_nis
            // looping result by nis with key as nis and boolean value
            for (const key in result_by_nis) {
              if (result_by_nis[key]) {
                successmessages += `<li>NIS ${key} berhasil diimpor order</li>`
                successCount++
              } else {
                failmessages += `<li>NIS ${key} gagal diimpor order</li>`
                failCount++
              }
            }
            failmessages += '</ul>'
            successmessages += '</ul>'
            const total = successCount + failCount
            const messages = `
              <h3>Result</h3>
              <p>Total baris: ${total}</p>
              <p>Impor order berhasil: ${successCount}</p>
              <div style="max-height: 200px; overflow-y: auto; border: 1px solid #ccc; padding: 5px;">
                ${successmessages}
              </div><br>
              <p>Impor order gagal: ${failCount}</p>
              <div style="max-height: 200px; overflow-y: auto; border: 1px solid #ccc; padding: 5px;">
                ${failmessages}
              </div>
            `

            // swal(`Berhasil membuat ${response.data.order.length} order`, "", "success")
            swal({
              title: 'Import VA Order',
              icon: 'success',
              className: 'swal-large',
              closeOnClickOutside: false,
              content: {
                element: 'div',
                attributes: {
                  innerHTML: messages + '</ul>',
                  style: 'text-align: left'
                }
              }
              // button: "OK",
            })
            this.va_file = ''
            // reset #import-file input file
            this.$refs.va_file.value = ''
            this.selected_bill = 0
          }).catch((e) => {
            this.va_file = ''
            // reset #import-file input file
            this.$refs.va_file.value = ''
            this.selected_bill = 0
            console.log(e)
            swal('Gagal melakukan request', '', 'error')
            console.log(e)
          }
          )
      } else if (fileName == 'expired_file') {
        if (!this.selected_bill2) {
          swal('Harap pilih tagihan yang akan digunakan', '', 'error')
          return
        }
        formData.append('spp_bill_id', this.selected_bill2)

        Promise.resolve(orderFactory.importVAExpired(formData))
          .then((response) => {
            // check if is set errmessage
            if (response.data.errmessage) {
              swal({
                title: 'Error',
                icon: 'error',
                // className: 'swal-large',
                closeOnClickOutside: false,
                content: {
                  element: 'div',
                  attributes: {
                    innerHTML: '<ul style="text-align: left">' + response.data.errmessage.map((err: any) => `<li>${err}</li>`).join('') + '</ul>',
                    style: 'text-align: left'
                  }
                }
                // button: "OK",
              })
              this.expired_file = ''
              // reset #import-file-expired input file
              this.$refs.expired_file.value = ''
              this.selected_bill2 = 0
              return
            }
            let failmessages = '<ul style="text-align: left">'
            let successmessages = '<ul style="text-align: left">'
            let successCount = 0
            let failCount = 0
            const result_by_nis = response.data.result_by_nis
            // looping result by nis with key as nis and boolean value
            for (const key in result_by_nis) {
              if (result_by_nis[key]) {
                successmessages += `<li>NIS ${key} berhasil diimpor expired</li>`
                successCount++
              } else {
                failmessages += `<li>NIS ${key} gagal diimpor expired</li>`
                failCount++
              }
            }
            failmessages += '</ul>'
            successmessages += '</ul>'
            const total = successCount + failCount
            const messages = `
              <h3>Result</h3>
              <p>Total baris: ${total}</p>
              <p>Impor expired berhasil: ${successCount}</p>
              <div style="max-height: 200px; overflow-y: auto; border: 1px solid #ccc; padding: 5px;">
                ${successmessages}
              </div><br>
              <p>Impor expired gagal: ${failCount}</p>
              <div style="max-height: 200px; overflow-y: auto; border: 1px solid #ccc; padding: 5px;">
                ${failmessages}
              </div>
            `

            // swal(`Berhasil membuat ${response.data.order.length} order`, "", "success")
            swal({
              title: 'Import VA Expired',
              icon: 'success',
              className: 'swal-large',
              closeOnClickOutside: false,
              content: {
                element: 'div',
                attributes: {
                  innerHTML: messages + '</ul>',
                  style: 'text-align: left'
                }
              }
              // button: "OK",
            })

            this.expired_file = ''
            // reset #import-file-expired input file
            this.$refs.expired_file.value = ''
            this.selected_bill2 = 0
          }).catch((e) => {
            this.expired_file = ''
            // reset #import-file-expired input file
            this.$refs.expired_file.value = ''
            this.selected_bill2 = 0
            swal('Gagal melakukan request', '', 'error')
            console.log(e)
          }
          )
      }
    },
    downloadTemplate: function () {
      Promise.resolve(orderFactory.downloadVAFileTemplate())
        .then(() => {

        }).catch((e) => {
          swal('Gagal melakukan request', '', 'error')
          console.log(e)
        })
    },
    getSchoolYear: function () {
      Promise.resolve(masterDataFactory.master_datas({ school_years: '1' }))
        .then(result => {
          const schoolYears = result.data.school_years
          schoolYears.forEach((school_year: any) => {
            if (school_year.status == 'Active') {
              return school_year.school_year_id
            }
          })
        }).catch((e) => {
          swal('Gagal melakukan request', '', 'error')
          console.log(e)
        })
    },
    getBill: function () {
      const param = {
        school_year_id: this.getSchoolYear()
      }
      Promise.resolve(billFactory.bill(param))
        .then(result => {
          this.bill_options = result.data.bills
        })
        .catch((e) => {
          swal('Gagal melakukan request', '', 'error')
          console.log(e)
        })
    }
  },
  async mounted () {
    // Check read access to /va-import
    if (!roleAccessManager.canRead('/va-import')) {
      swal('Error', 'Anda tidak memiliki akses ke halaman ini', 'error')
        .then(() => {
          this.$router.push('/loginpage')
        })
      return
    }

    // Set permission flags
    this.canCreate = roleAccessManager.canCreate('/va-import')
    this.canRead = roleAccessManager.canRead('/va-import')
    this.canUpdate = roleAccessManager.canUpdate('/va-import')
    this.canDelete = roleAccessManager.canDelete('/va-import')

    await this.getBill()
  }
})

export default class VAImport extends Vue {}
